import { Button, Card } from "react-bootstrap";
import { getDashboardUrl } from "../../config";

const PlanCard = ({ planType, keyType }) => {
  const planDescriptions = {
    Single: `Perfect for one person and a trusted supporter helping manage everyday life.`,

    Couple: `For couples, partners or close family support.`,

    Family: `For families supporting multiple loved ones together.`,
  };

  const planBulletPoints = {
    Single: [
      "One person + trusted supporter",
      "Shared reminders & organisation",
      "Household & renewal tracking",
      "Peace of mind for everyday life"
    ],
    Couple: [
      "Everything in Single Support",
      "Support each other together",
      "Shared organisation tools",
      "Multiple trusted supporters",
      "Designed for couples & families"
    ],
    Family: [
      "Everything in Joint Support",
      "Support multiple loved ones",
      "Shared household organisation",
      "Family-wide support access",
      "Built for connected care"
    ]
  };

  return (
    <Card className="border-0 shadow position-relative overflow-hidden h-100 d-flex flex-column">
      {planType.name === "Family" && (
        <span className="card-ribbon fw-bold text-dark small text-center py-2 mb-0">
          Best value
        </span>
      )}
      <Card.Body className="p-6 p-md-7 d-flex flex-column">
        <h2 className="h5 mb-4 mb-md-5">
          <span>
            {planType.name === "Single"
              ? "Single"
              : planType.name === "Couple"
              ? "Joint"
              : planType.name === "Family"
              ? "Shared"
              : planType.name}{" "}
            Support
          </span>
        </h2>
        <div className="text-info lh-sm mb-0">
          {keyType === "yearly" ? (
            <div>
              <p className="fs-3 fw-bold mb-2">£{planType.monthlyPrice}</p>
              <p className="small text-dark mb-1">per month</p>
              <p className="text-dark mb-5 mb-md-6">
                Billed annually as{" "}
                <span className="text-info fw-bold">£{planType.price}</span>
              </p>
            </div>
          ) : (
            <div>
              <span className="fs-3 fw-bold">£{planType.price}</span>
              <div className="small text-dark mb-5 mb-md-6">
                per {keyType === "yearly" ? "year" : "month"}
              </div>
            </div>
          )}
        </div>
        <p style={{ minHeight: "90px" }}>{planDescriptions[planType.name]}</p>
        <ul className="list-unstyled list-checked text-dark mb-5 mb-md-6" style={{ minHeight: "200px" }}>
          {planBulletPoints[planType.name]?.map((item, idx) => (
            <li key={idx} className="list-item d-flex align-items-center mb-2">
              <i className="fa fa-solid fa-check text-success"></i>
              <span className="ms-3">{item}</span>
            </li>
          ))}
        </ul>
        <Button
          variant="primary"
          className="w-100 mt-auto"
          href={`${getDashboardUrl()}/signup?plan=${planType.name.toLowerCase()}&billing=${keyType}`}
          target="_blank"
        >
          Start Free Trial
        </Button>
      </Card.Body>
    </Card>
  );
};

export default PlanCard;
